import { render, staticRenderFns } from "./WholeMessage.vue?vue&type=template&id=617948d0&scoped=true&"
import script from "./WholeMessage.vue?vue&type=script&lang=js&"
export * from "./WholeMessage.vue?vue&type=script&lang=js&"
import style1 from "./WholeMessage.vue?vue&type=style&index=1&id=617948d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617948d0",
  null
  
)

export default component.exports